import { isViewOnlyUser } from '@app/shared/common/view-only/view-only.directive';
import { PermissionCheckerService } from 'abp-ng2-module';
import { AppSessionService } from '@shared/common/session/app-session.service';

import { Injectable } from '@angular/core';
import { AppMenu } from './app-menu';
import { AppMenuItem } from './app-menu-item';

/** Top-level menus hidden for view-only users even though they hold these permissions. */
const ViewOnlyHiddenMenuPermissions = ['Pages.Tenant.TTWLead', 'Pages.Tenant.TTWTicketHolder'];

@Injectable()
export class AppNavigationService {
    constructor(
        private _permissionCheckerService: PermissionCheckerService,
        private _appSessionService: AppSessionService
    ) { }

    getMenu(): AppMenu {
        return new AppMenu('MainMenu', 'MainMenu', [
            new AppMenuItem(
                'Dashboard',
                'Pages.Administration.Host.Dashboard',
                'flaticon-line-graph',
                '/app/admin/hostDashboard'
            ),
            new AppMenuItem('Dashboard', 'Pages.Tenant.Dashboard', 'flaticon-line-graph', '/app/main/dashboard'),

            // Add Custom Menu here
            new AppMenuItem('Reports', 'Pages.Tenant.Reports', 'flaticon-analytics', '/app/main/reports'),
            new AppMenuItem("Lead", 'Pages.Tenant.TTWLead', "fas fa-user-tie", '', [], [
                new AppMenuItem('Lead Queue', 'Pages.Tenant.TTWLead.LeadQ', 'pi pi-list', '/app/main/lead/lead-queue'),
                new AppMenuItem('Lead Pool', 'Pages.Tenant.TTWLead.AllLead', 'pi pi-users', '/app/main/lead/lead-pool'),
                new AppMenuItem('Interested', 'Pages.Tenant.TTWLead.AllLead', 'pi pi-face-smile', '/app/main/lead/interested'),
                    // new AppMenuItem('Disqualified', '', 'pi pi-times-circle', '/app/main/lead/disqualified-lead'),
                    // new AppMenuItem('Not Interested', '', 'pi pi-ban', '/app/main/lead/not-interested'),
                    new AppMenuItem('All Lead', 'Pages.Tenant.TTWLead.AllLead', 'pi pi-table', '/app/main/lead/lead-all'),
                    new AppMenuItem('Create Lead', 'Pages.Tenant.TTWLead.CreateLead', 'pi pi-user-plus', '/app/main/lead/create-lead'),
                    new AppMenuItem('Eligibility Checking', 'Pages.Tenant.TTWLead.Eligibility', 'pi pi-check-circle', '/app/main/lead/eligibility'),
                    new AppMenuItem('Contact History', 'Pages.Tenant.TTWLead.ContactHistory', 'far fa-address-book', '/app/main/lead/contactHistory'),
            ]),
            new AppMenuItem("Campaign", 'Pages.Tenant.TTWCampaign', "pi pi-chart-line", '', [],
                [
                    new AppMenuItem('All Campaign', 'Pages.Tenant.TTWCampaign.AllCampaigns', 'far fa-list-alt', '/app/main/campaign/all-campaign'),
                    new AppMenuItem('Campaign History', 'Pages.Tenant.TTWCampaign.CampaignHistory', 'far fa-clock', '/app/main/campaign/campaign-history'),
                    new AppMenuItem('Campaign Responses', 'Pages.Tenant.TTWCampaign.CampaignResponses', 'far fa-comments', '/app/main/campaign/campaign-responses'),
                ]),
            new AppMenuItem("Marketing", 'Pages.Tenant.TTWMarketing', "pi pi-megaphone", '', [],
                [
                    new AppMenuItem('Dashboard', 'Pages.Tenant.TTWMarketing', 'pi pi-chart-bar', '/app/main/marketing/dashboard'),
                    new AppMenuItem('VR Partnership', 'Pages.Tenant.TTWMarketing.Organizations', 'pi pi-building', '/app/main/marketing/vr-partnership'),
                    new AppMenuItem('Business Partners', 'Pages.Tenant.TTWMarketing.Organizations', 'pi pi-briefcase', '/app/main/marketing/business-partners'),
                    new AppMenuItem('Campaigns', 'Pages.Tenant.TTWMarketing', 'pi pi-share-alt', '/app/main/marketing/campaigns'),
                    new AppMenuItem('Contacts', 'Pages.Tenant.TTWMarketing.Contacts', 'pi pi-users', '/app/main/marketing/contacts'),
                    new AppMenuItem('Contact History', 'Pages.Tenant.TTWMarketing.ContactHistory', 'far fa-address-book', '/app/main/marketing/contact-history'),
                    new AppMenuItem('Events', 'Pages.Tenant.TTWMarketing.Events', 'pi pi-calendar', '/app/main/marketing/events'),
                    new AppMenuItem('Checklist Templates', 'Pages.Tenant.TTWMarketing.Events', 'pi pi-list-check', '/app/main/marketing/checklist-templates'),
                    new AppMenuItem('Email Templates', 'Pages.Tenant.TTWMarketing', 'pi pi-envelope', '/app/main/marketing/email-templates'),
                    new AppMenuItem('Import','Pages.Tenant.TTWMarketing.Import', 'pi pi-file-import', '/app/main/marketing/import'),
                ]),
            new AppMenuItem("IWP", 'Pages.Tenant.TTWIWP', "pi pi-file-pdf", '', [],
                [
                    // Pending / Unsigned / Signed / Deleted IWPs as tabs; each tab checks its own permission.
                    new AppMenuItem('IWP List', 'Pages.Tenant.TTWIWP.IWPQ|Pages.Tenant.TTWIWP.SigningStatus', 'pi pi-crown', '/app/main/iwp/iwp-list'),
                    new AppMenuItem('IWP Generator', 'Pages.Tenant.TTWIWP', 'pi pi-sparkles', '/app/main/iwp/iwp-generator'),
                ]),
            new AppMenuItem("Ticket Holder", 'Pages.Tenant.TTWTicketHolder', "pi pi-ticket", '', [],
                [
                    new AppMenuItem('My Ticket Holder', 'Pages.Tenant.TTWTicketHolder.MyTicketHolders', 'far fa-user', '/app/main/ticket-holder/list'),
                    new AppMenuItem('Contact History', 'Pages.Tenant.TTWTicketHolder.ContactHistories', 'far fa-address-book', '/app/main/ticket-holder/contacts'),
                    new AppMenuItem('Job Search Request', 'Pages.Tenant.TTWJobs', 'pi pi-search', '/app/main/ticket-holder/job-search-request'),
                    new AppMenuItem('BPQY', '', 'pi pi-file-check', '/app/main/ticket-holder/bpqy-list'),
                ]),
            new AppMenuItem("Benefits Counseling", 'Pages.Tenant.TTWBenefitsCounseling.Read', 'pi pi-shield', '/app/main/ticket-holder/benefits-counseling-cases'),
            new AppMenuItem("Operation", 'Pages.Tenant.TTWOperation', "far fa-cogs", '', [],
                [
                    new AppMenuItem('Ticketholder Management', 'Pages.Tenant.TTWOperation.TicketHolderManagement', 'pi pi-file-check', '/app/main/operation/ticket-holder'),
                    new AppMenuItem('Assign JSA', 'Pages.Tenant.TTWOperation.AssignJSA', 'pi pi-file-check', '/app/main/operation/assign-job-search-assistance'),
                    new AppMenuItem('Job Search Request', 'Pages.Tenant.TTWOperation.JobSearchRequest', 'pi pi-search', '/app/main/operation/job-search-request'),
                    new AppMenuItem('Check-in Lead', 'Pages.Tenant.TTWOperation.CheckinLeads', 'far fa-check-circle', '/app/main/operation/check-in-lead'),
                    new AppMenuItem('Interested Leads', 'Pages.Tenant.TTWOperation.InterestedLeadsManagement', 'pi pi-user-plus', '/app/main/operation/interested-leads-management'),
                    new AppMenuItem('Unknown Income Fax', 'Pages.Tenant.TTWOperation.UnknownIncomeFax', 'far fa-fax', '/app/main/operation/unknown-income-fax'),
                    new AppMenuItem('Import Lead', 'Pages.Tenant.TTWOperation.ImportLeads', 'pi pi-file-word', '/app/main/operation/import-leads'),
                    new AppMenuItem('Outgoing Mails', 'Pages.Tenant.TTWOperation.OutgoingMails', 'far fa-paper-plane', '/app/main/operation/outgoing-mails'),
                    new AppMenuItem('IWP Review Q', 'Pages.Tenant.TTWOperation.IWPReviewQ', 'far fa-eye', '/app/main/operation/iwp-review-q'),
                    new AppMenuItem('Referral Management', 'Pages.Tenant.TTWOperation.Referral', 'pi pi-share-alt', '/app/main/operation/referral-management'),
                    new AppMenuItem('Ref Partner Management', 'Pages.Tenant.TTWOperation.ReferralPartner', 'pi pi-users', '/app/main/operation/referral-partner-management'),
                    new AppMenuItem('Phone Log Analysis', 'Pages.Tenant.TTWOperation.RingCentralCallLog', 'pi pi-phone', '/app/main/operation/ring-central-call-logs'),
                    new AppMenuItem('Two Way Management', 'Pages.Tenant.TTWOperation.TwoWayManagement', 'pi pi-comments', '/app/main/operation/two-way-management'),
                    new AppMenuItem('PII Review Queue', 'Pages.Tenant.TTWOperation.PiiReviewQueue', 'pi pi-shield', '/app/main/operation/pii-review-queue'),
                    new AppMenuItem('Opt-Out Management', 'Pages.Tenant.TTWOperation.OptOutManagement', 'pi pi-ban', '/app/main/operation/opt-out-management'),
                    new AppMenuItem('Ticket Holder Logins', 'Pages.Tenant.TTWOperation.TicketHolderLogins', 'pi pi-sign-in', '/app/main/operation/ticket-holder-logins'),
                ]),
            new AppMenuItem("SSA", 'Pages.Tenant.TTWSSA', "pi pi-building-columns", '', [],
                [
                    new AppMenuItem('Eligibility Verification', 'Pages.Tenant.TTWSSA.EligibilityVerification', 'far fa-id-badge', '/app/main/ssa/eligibility-verification'),
                    new AppMenuItem('Ticket Assign / Unassign', 'Pages.Tenant.TTWSSA.TicketAssignment|Pages.Tenant.TTWSSA.TicketUnassignment', 'pi pi-id-card', '/app/main/ssa/ticket-assignment'),
                    new AppMenuItem('Program Integrity', 'Pages.Tenant.TTWSSA.ProgramIntegrity', 'pi pi-verified', '/app/main/ssa/program-integrity'),
                    new AppMenuItem('Staff Suitability', 'Pages.Tenant.TTWSSA.Suitability', 'pi pi-shield', '/app/main/ssa/suitability'),
                ]),
            new AppMenuItem("Billing Management", 'Pages.Tenant.TTWBilling', "pi pi-money-bill", '', [],
                [
                    new AppMenuItem('Active Ticketholder', '', 'pi pi-users', '/app/main/billing-management/active-ticketholder'),
                    new AppMenuItem('Wage Data Request', 'Pages.Tenant.TTWBilling.WageDataRequest', 'pi pi-file-edit', '/app/main/billing-management/wage-data-request'),
                    new AppMenuItem('Assign Wage Report', 'Pages.Tenant.TTWBilling.AssignWageReport', 'pi pi-user-edit', '/app/main/billing-management/assign-wage-report'),
                    new AppMenuItem('Process Wage Report', 'Pages.Tenant.TTWBilling.ProcessWageReport', 'pi pi-cog', '/app/main/billing-management/process-wage-report'),
                    new AppMenuItem('Payment Request', 'Pages.Tenant.TTWBilling.CreatePaymentRequest', 'pi pi-send', '/app/main/billing-management/payment-request'),
                    new AppMenuItem('Payment Request Status', 'Pages.Tenant.TTWBilling.PaymentRequestStatus', 'pi pi-chart-bar', '/app/main/billing-management/payment-request-status'),
                    new AppMenuItem('Process OSM', 'Pages.Tenant.TTWBilling.ProcessOSM', 'pi pi-sync', '/app/main/billing-management/process-osm'),
                    new AppMenuItem('Portal Bill', 'Pages.Tenant.TTWBilling.PaymentDispute', 'pi pi-receipt', '/app/main/billing-management/portal-bill'),
                ]),
            new AppMenuItem('Saas', 'Pages.Tenants', 'far fa-cloud', '', [],
                [
                    new AppMenuItem('Tenants', 'Pages.Tenants', 'far fa-building', '/app/admin/tenants'),
                    new AppMenuItem('Document Template', 'Pages.Tenants', 'far fa-file', '/app/admin/host-doc-template'),
                    new AppMenuItem('Phase Milestone', 'Pages.Tenants', 'far fa-calendar-alt', '/app/admin/phase-milestone'),
                    new AppMenuItem('Benefit Reference Data', 'Pages.Tenants', 'far fa-file-alt', '/app/admin/benefit-reference'),
                    new AppMenuItem('Editions', 'Pages.Editions', 'far fa-copy', '/app/admin/editions'),
                    new AppMenuItem('Background Task', '', 'far fa-copy', '/app/admin/background-task/bg-task'),
                    new AppMenuItem('AI Voice Agents', 'Pages.AIAgent.Administration.ManageProviders', 'far fa-comment-dots', '/app/admin/ai-voice-agent'),
                    new AppMenuItem(
                        // TEMP: permission left blank so the menu item shows immediately for local
                        // testing without needing a fresh login/permission-cache refresh. The
                        // TestAutomationAppService endpoints are still gated server-side by
                        // Pages.Administration.TestAutomation (see AppAuthorizationProvider), so this
                        // does not weaken actual access control — restore the permission name below
                        // once confirmed granted, so the menu itself is hidden from unauthorized users too.
                        'Test Automation',
                        '',
                        'flaticon-refresh',
                        '/app/admin/test-automation'
                    ),
                ],
            ),
            new AppMenuItem('Administration', 'Pages.Administration', 'flaticon-interface-8', '', [],
                [
                    new AppMenuItem(
                        'OrganizationUnits',
                        'Pages.Administration.OrganizationUnits',
                        'flaticon-map',
                        '/app/admin/organization-units'
                    ),
                    new AppMenuItem('Roles', 'Pages.Administration.Roles', 'flaticon-suitcase', '/app/admin/roles'),
                    new AppMenuItem('Users', 'Pages.Administration.Users', 'flaticon-users', '/app/admin/users'),
                    new AppMenuItem(
                        'Languages',
                        'Pages.Administration.Languages',
                        'flaticon-tabs',
                        '/app/admin/languages',
                        ['/app/admin/languages/{name}/texts']
                    ),
                    new AppMenuItem(
                        'AuditLogs',
                        'Pages.Administration.AuditLogs',
                        'flaticon-folder-1',
                        '/app/admin/auditLogs'
                    ),
                    new AppMenuItem(
                        'Maintenance',
                        'Pages.Administration.Host.Maintenance',
                        'flaticon-lock',
                        '/app/admin/maintenance'
                    ),
                    new AppMenuItem(
                        'Token Extender Monitor',
                        'Pages.Administration.Host.Maintenance',
                        'pi pi-calendar-clock',
                        '/app/admin/token-extender-monitor'
                    ),
                    new AppMenuItem(
                        'Subscription',
                        'Pages.Administration.Tenant.SubscriptionManagement',
                        'flaticon-refresh',
                        '/app/admin/subscription-management'
                    ),
                    new AppMenuItem(
                        'VisualSettings',
                        'Pages.Administration.UiCustomization',
                        'flaticon-medical',
                        '/app/admin/ui-customization'
                    ),
                    new AppMenuItem(
                        'WebhookSubscriptions',
                        'Pages.Administration.WebhookSubscription',
                        'flaticon2-world',
                        '/app/admin/webhook-subscriptions'
                    ),
                    new AppMenuItem(
                        'DynamicProperties',
                        'Pages.Administration.DynamicProperties',
                        'flaticon-interface-8',
                        '/app/admin/dynamic-property'
                    ),
                    new AppMenuItem(
                        'Notifications',
                        '',
                        'flaticon-alarm',
                        '',
                        [],
                        [
                            new AppMenuItem(
                                'Inbox',
                                '',
                                'flaticon-mail-1',
                                '/app/notifications'
                            ),
                            new AppMenuItem(
                                'MassNotifications',
                                'Pages.Administration.MassNotification',
                                'flaticon-paper-plane',
                                '/app/admin/mass-notifications'
                            )
                        ]
                            ),
                    new AppMenuItem(
                        'Survey Management',
                        'Pages.Administration.TTWSurveyManagement',
                        'flaticon-settings',
                        '/app/admin/surveyMgmt/que-list'
                    ),
                    new AppMenuItem(
                        'Document Template',
                        'Pages.Administration.TTWTemplateSetup',
                        'flaticon-settings',
                        '/app/admin/docMgmt/doc-list'
                    ),
                    new AppMenuItem(
                        'Task Template',
                        'Pages.Administration.TaskTemplates',
                        'pi pi-list-check',
                        '/app/admin/task/task-management'
                    ),
                    new AppMenuItem(
                        'SSA Contacts',
                        'Pages.Administration.SsaContacts',
                        'pi pi-id-card',
                        '/app/admin/ssaContacts'
                    ),
                    new AppMenuItem(
                        'Background Process',
                        'Pages.Administration.TTWBackgroundProcesses',
                        'flaticon-settings',
                        '/app/admin/backgroundProcess/background-process-list'
                    ),
                    new AppMenuItem(
                        'Contact Us',
                        'Pages.Administration.WebsiteContactUs',
                        'pi pi-envelope',
                        '/app/admin/web-contact-us'
                    ),
                    new AppMenuItem(
                        'Schedule Demo',
                        'Pages.Administration.WebsiteScheduleDemo',
                        'pi pi-calendar-plus',
                        '/app/admin/web-schedule-demo'
                    ),
                    new AppMenuItem(
                        'AI Invoice',
                        '',
                        'pi pi-receipt',
                        '/app/admin/ai-invoice'
                    ),
                    new AppMenuItem(
                        'Report Management',
                        'Pages.Administration.Reports',
                        'flaticon-analytics',
                        '',
                        [],
                        [
                            new AppMenuItem(
                                'Reports',
                                'Pages.Administration.Reports',
                                'flaticon-list',
                                '/app/admin/report-management/reports'
                            ),
                            new AppMenuItem(
                                'Report Requests',
                                'Pages.Administration.Reports.Requests',
                                'flaticon-mail-1',
                                '/app/admin/report-management/report-requests'
                            ),
                        ]
                    ),
                    new AppMenuItem(
                        'Settings',
                        'Pages.Administration.Host.Settings',
                        'flaticon-settings',
                        '/app/admin/hostSettings'
                    ),
                    new AppMenuItem(
                        'Settings',
                        'Pages.Administration.Tenant.Settings',
                        'flaticon-settings',
                        '/app/admin/tenantSettings'
                    )
                ]
            ),
            new AppMenuItem('Setup Guide', 'Pages.Administration.TTWSetupGuide', 'pi pi-book', '', [], [
                new AppMenuItem('DigiSigner', '', 'pi pi-file-edit', '/app/admin/setup-guides/digisigner'),
                // new AppMenuItem('Twilio SMS', '', 'pi pi-comments', '/app/admin/setup-guides/twilio'),
                // new AppMenuItem('Gmail', '', 'pi pi-google', '/app/admin/setup-guides/gmail'),
                new AppMenuItem('SMTP Email', '', 'pi pi-server', '/app/admin/setup-guides/smtp'),
                new AppMenuItem('Microsoft Email', '', 'pi pi-envelope', '/app/admin/setup-guides/microsoft-email'),
                new AppMenuItem('RingCentral (Fax, SMS & Phone)', '', 'pi pi-phone', '/app/admin/setup-guides/ringcentral'),
                new AppMenuItem('Voice Agent', '', 'pi pi-microphone', '/app/admin/setup-guides/voice-agent'),
            ]),
            new AppMenuItem('DemoUiComponents', 'Pages.DemoUiComponents', 'flaticon-shapes', '/app/admin/demo-ui-components'),

            // This is for Ticket Holder Web Portal
            new AppMenuItem('My Calendar', 'Pages.Tenant.TicketHolderClient.Appointment', 'pi pi-calendar', '/app/ticket-holder-web-portal/my-appointments'),

            new AppMenuItem("Communication", '', "pi pi-comments", '', [], [
                new AppMenuItem('My Career Coach', 'Pages.Tenant.TicketHolderClient.MyCCDetails', 'pi pi-user', '/app/ticket-holder-web-portal/my-cc-details'),
                new AppMenuItem('Chat With Career Coach', 'Pages.Tenant.TicketHolderClient.Communication', 'pi pi-comment', '/app/ticket-holder-web-portal/live-chat-with-cc'),
                new AppMenuItem('Contact History', 'Pages.Tenant.TicketHolderClient.ContactHistory', 'pi pi-history', '/app/ticket-holder-web-portal/contact-history'),
            ]),
            new AppMenuItem("Job & Employment", '', "pi pi-briefcase", '', [], [
                new AppMenuItem('Job Management', 'Pages.Tenant.TicketHolderClient.Jobs', 'pi pi-search', '/app/ticket-holder-web-portal/job-management/pending',
                    // Every tab and the job details page keep the menu open on this item.
                    ['/app/ticket-holder-web-portal/job-management/{tab}', '/app/ticket-holder-web-portal/job-management/job-details/{jobId}']),
                new AppMenuItem('Manage Password', 'Pages.Tenant.TicketHolderClient.CredentialManagement', 'pi pi-key', '/app/ticket-holder-web-portal/password-management'),
                new AppMenuItem('Employment History', 'Pages.Tenant.TicketHolderClient.WorkHistory', 'pi pi-id-card', '/app/ticket-holder-web-portal/employment-history'),
                new AppMenuItem('Pay History', 'Pages.Tenant.TicketHolderClient.PayHistory', 'pi pi-wallet', '/app/ticket-holder-web-portal/pay-history',
                    ['/app/ticket-holder-web-portal/pay-history/{page}']),
            ]),
            new AppMenuItem('My Documents', 'Pages.Tenant.TicketHolderClient.Document', 'pi pi-folder-open', '/app/ticket-holder-web-portal/document-management'),
            new AppMenuItem('Request Services', 'Pages.Tenant.TicketHolderClient.ServiceRequest', 'pi pi-inbox', '/app/ticket-holder-web-portal/service-request'),
            this.ticketHolderSettingsItem(),

            // This is for Job Search Assistance Portal
            new AppMenuItem("Job Assistance", 'Pages.Tenant.TTWJSA', "flaticon-suitcase", '', [],
                [
                    new AppMenuItem('Job A. Manager', 'Pages.Tenant.TTWJSA.Manager', 'pi pi-user', '/app/main/job-assistance/manage-job-search-request'),
                    new AppMenuItem('Job Search Request', 'Pages.Tenant.TTWJSA.JobSearchRequest', 'pi pi-crown', '/app/main/job-assistance/job-search-request/pending'),
                ]),
        ]);
    }

    /** permissionName may list alternatives as 'A|B': the item shows when any one of them is granted. */
    private isAnyGranted(permissionName: string): boolean {
        return permissionName.split('|').some((name) => this._permissionCheckerService.isGranted(name));
    }

    // Ticket holder portal: "My Settings" opens the My Settings dialog (it has no page of its own).
    private ticketHolderSettingsItem(): AppMenuItem {
        const item = new AppMenuItem('My Settings', 'Pages.Tenant.TicketHolderClient', 'pi pi-cog', '/app/ticket-holder-web-portal/my-settings');
        item.action = 'mySettings';
        return item;
    }

    checkChildMenuItemPermission(menuItem): boolean {
        for (let i = 0; i < menuItem.items.length; i++) {
            let subMenuItem = menuItem.items[i];

            if (subMenuItem.permissionName === '' || subMenuItem.permissionName === null) {
                if (subMenuItem.route) {
                    return true;
                }
            } else if (this.isAnyGranted(subMenuItem.permissionName)) {
                if (!subMenuItem.hasFeatureDependency()) {
                    return true;
                }

                if (subMenuItem.featureDependencySatisfied()) {
                    return true;
                }
            }

            if (subMenuItem.items && subMenuItem.items.length) {
                let isAnyChildItemActive = this.checkChildMenuItemPermission(subMenuItem);
                if (isAnyChildItemActive) {
                    return true;
                }
            }
        }

        return false;
    }

    showMenuItem(menuItem: AppMenuItem): boolean {
        if (
            menuItem.permissionName === 'Pages.Administration.Tenant.SubscriptionManagement' &&
            this._appSessionService.tenant &&
            !this._appSessionService.tenant.edition
        ) {
            return false;
        }

        let hideMenuItem = false;

        if (menuItem.requiresAuthentication && !this._appSessionService.user) {
            hideMenuItem = true;
        }

        if (menuItem.permissionName && !this.isAnyGranted(menuItem.permissionName)) {
            hideMenuItem = true;
        }

        // View-only users (TPA) open lead / ticket holder details from Operation only: they hold the module
        // permissions the detail pages need, but must not get the Lead / Ticket Holder menus.
        if (ViewOnlyHiddenMenuPermissions.includes(menuItem.permissionName)
            && isViewOnlyUser((p) => this._permissionCheckerService.isGranted(p))) {
            hideMenuItem = true;
        }

        if (this._appSessionService.tenant || !abp.multiTenancy.ignoreFeatureCheckForHostUsers) {
            if (menuItem.hasFeatureDependency() && !menuItem.featureDependencySatisfied()) {
                hideMenuItem = true;
            }
        }

        if (!hideMenuItem && menuItem.items && menuItem.items.length) {
            return this.checkChildMenuItemPermission(menuItem);
        }

        return !hideMenuItem;
    }

    /**
     * Returns all menu items recursively
     */
    getAllMenuItems(): AppMenuItem[] {
        let menu = this.getMenu();
        let allMenuItems: AppMenuItem[] = [];
        menu.items.forEach((menuItem) => {
            allMenuItems = allMenuItems.concat(this.getAllMenuItemsRecursive(menuItem));
        });

        return allMenuItems;
    }

    private getAllMenuItemsRecursive(menuItem: AppMenuItem): AppMenuItem[] {
        if (!menuItem.items) {
            return [menuItem];
        }

        let menuItems = [menuItem];
        menuItem.items.forEach((subMenu) => {
            menuItems = menuItems.concat(this.getAllMenuItemsRecursive(subMenu));
        });

        return menuItems;
    }
}
